"use client";
import { Info } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/app/components/shadcn/popover";
import { RosetteInfo } from "@/app/lib/features/accountMenu/accountMenu.types";

interface RosetteInfoPopoverProps {
  rosetteInfo: RosetteInfo;
  side?: "left" | "right" | "top" | "bottom";
}

const RosetteInfoPopover = ({
  rosetteInfo,
  side = "left",
}: RosetteInfoPopoverProps) => {
  if (!rosetteInfo.infos || rosetteInfo.infos.length === 0) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className="text-white/60 hover:text-white transition-colors"
          onClick={(e) => e.stopPropagation()}
        >
          <Info size={15} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80" side={side} align="start">
        <div>
          <div className="mb-3">
            <p className="text-base font-bold text-gray-900">Statünüz:</p>
            <p className="text-xs text-gray-500">
              Mevcut statü:{" "}
              <span className="font-semibold">{rosetteInfo.name}</span>
            </p>
          </div>
          <div className="space-y-3">
            {rosetteInfo.infos.map((level) => {
              const isActive = level.name === rosetteInfo.value;
              const subtitle = level.threshold || "Başlangıç seviyesi";
              return (
                <div
                  key={level.name}
                  className="rounded-xl p-2.5 text-white"
                  style={{ backgroundColor: level.color }}
                >
                  <span className="inline-block text-[10px] font-bold tracking-wider bg-white/20 rounded-full px-2.5 py-1 mb-2">
                    {isActive ? "AKTİF STATÜ" : "STATÜ"}
                  </span>
                  <p className="text-sm font-bold leading-tight">{level.name}</p>
                  <p className="text-[11px] font-medium mt-0.5 text-white/90">
                    {subtitle}
                  </p>
                  <p className="text-[11px] text-white/80 mt-1 leading-relaxed">
                    {level.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default RosetteInfoPopover;
